import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "./client"

export interface TripBookingDetails {
  guestCount: number
  checkInDate: number
  checkoutDate: number
  bookingDate: number
  bookingConfirmationCode: string
  bookingStatus: string
  totalAmount: number
  checkinTime?: string
  checkoutTime?: string
}

export interface TripDetailsResponseData {
  channelUrl: string | null
  tripBookingDetails: TripBookingDetails
  propertyName: string
  city: string
  state: string
  hostName: string
  coverImage: string
  hostProfileUrl: string
}

export interface TripDetailsRequest extends Partial<AxiosRequestConfig> {
  channelUrl: string
}

export interface TripDetailsResponse extends AxiosResponse {
  data: {
    data: TripDetailsResponseData
  }
}

export function getTripDetailsApi(
  {
    channelUrl,
    method = "get",
    url = `${
      process.env.REACT_APP_BASE_API_URL || ""
    }/sendbird/get-trip-details?channelUrl=${channelUrl}`,
    ...config
  }: TripDetailsRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<TripDetailsResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<TripDetailsResponse>
}
